import { DataLayer } from '@utility/data-layer';

import type {
  ScaAppEventsDeclaration,
  ScaAppGlobalEventProperties,
} from '../models/globals/events.types';

export const dataLayer = DataLayer.getInstance<
  ScaAppEventsDeclaration,
  ScaAppGlobalEventProperties
>();
